import React from "react";
import imgHome from "../assets/cait.png";
import logo from "../assets/wito.png";
import Slider from "../utils/home/slider";
import CustomButton from "../utils/home/custom_button";

const images = [
  "https://cloudfront-us-east-1.images.arcpublishing.com/eluniverso/MRNI2GIF5FC5LDRDD43AQDOXFQ.jpg",
  "https://s1.significados.com/foto/imagen-de-destaque-que-es-el-futbol.-jugadores-y-balon.jpg",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AfkWlpCMOdxqNWi28h3Zv7pI70mciJiWrQ&s",
];

const Create = () => {
  return (
    <div className="flex flex-col items-center  min-h-screen">
      <div className="flex justify-center items-center w-full mb-6 mt-7">
        <img
          src={logo}
          alt="Logo"
          style={{ height: "40px" }}
          className="mr-2"
        />
      </div>

      <div className="flex justify-center items-center w-full mb-14">
        <Slider images={images} width={380} height={250} />
      </div>

      <div className="justify-center items-center">
        <CustomButton text="Torneo" to="/create-tournament" />
        <CustomButton text="Equipo" to="/create-team" />
        <CustomButton text="Jugador" to="/player-profile" />
      </div>
    </div>
  );
};

export default Create;
